var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchStars({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2L13.971 10.029L22 13L13.971 15.971L11 24L8.029 15.971L0 13L8.029 10.029L11 2Z",
    fill: "url(#paint0_linear_715_1788)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0L21.7154 3.28459L25 4.5L21.7154 5.71541L20.5 9L19.2846 5.71541L16 4.5L19.2846 3.28459L20.5 0Z",
    fill: "url(#paint1_linear_715_1788)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_1788",
    x1: 3,
    y1: 24,
    x2: 21.9705,
    y2: 0.989836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#51C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_1788",
    x1: 17.2273,
    y1: 9,
    x2: 24.9879,
    y2: -0.413249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#51C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchStars);
export default __webpack_public_path__ + "static/media/search_stars.05ed4973a02e965c2ed8b1e2d1926237.svg";
export { ForwardRef as ReactComponent };